var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.9146 10.7195H3.32131C3.59082 13.1909 5.47923 15.1774 7.90057 15.6049C8.06582 15.8433 8.34021 16 8.6524 16H10.3115C10.8164 16 11.2262 15.5909 11.2262 15.0854C11.2262 14.5799 10.8164 14.1707 10.3115 14.1707H8.6524C8.42374 14.1707 8.21704 14.2579 8.05667 14.3963C6.03838 14.0128 4.50606 12.2384 4.50606 10.1098V6.19512C4.50606 3.45183 6.73777 1.22012 9.48167 1.22012C12.2256 1.22012 14.4573 3.45183 14.4573 6.19512V10.1098C14.4573 10.4451 14.7317 10.7195 15.067 10.7195H16.0487C17.1219 10.7195 18 9.84146 18 8.76219V7.54268C18 6.46341 17.1219 5.58537 16.0487 5.58537H15.6457C15.3384 2.45427 12.6914 0 9.48167 0C6.27192 0 3.62496 2.45427 3.31765 5.58537H2.9146C1.84143 5.58537 0.963379 6.46341 0.963379 7.54268V8.76219C0.963379 9.84146 1.84143 10.7195 2.9146 10.7195Z",
    fill: "#696974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalling);
export default __webpack_public_path__ + "static/media/calling.add76b884a18206b75be3dbc87c703b9.svg";
export { ForwardRef as ReactComponent };